import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ROUTE } from '../../shared/constants';
import { Subject } from 'rxjs';
import { FormBuilder } from '@angular/forms';

import { APIComponent } from '../../shared/api.component';
import { AccountLoopBackApiService } from '../../services/api/loopback/custom/account.service';
import { BaseLoopBackStorageService } from '../../services/storage/loopback/base.service';

@Component({
  selector: 'drx-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent extends APIComponent {

  public constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected formBuilder: FormBuilder,
    protected storageService: BaseLoopBackStorageService,
    protected apiService: AccountLoopBackApiService
  ) {
    super(route, router, formBuilder, storageService, apiService);
  }

  public ngOnInit() {
    this.logout();
  }

  logout() {
    this.apiService.logout()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((response) => {
        this.storageService.clear();
        this.router.navigate([ROUTE.LOGIN]);
      }, (error) => {
        this.storageService.clear();
        this.router.navigate([ROUTE.LOGIN]);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/logout/logout.component.ts